import { render, staticRenderFns } from "./UsersMultiselect.vue?vue&type=template&id=99d35aa4&"
import script from "./UsersMultiselect.vue?vue&type=script&lang=js&"
export * from "./UsersMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./UsersMultiselect.vue?vue&type=style&index=0&id=99d35aa4&prod&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports